import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", {
  fill: "none",
  "fill-rule": "evenodd",
  stroke: "currentColor",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  transform: "translate(4 3)"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    width: "16",
    height: "9.778",
    y: "8",
    rx: "1"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    d: "M3.556 8V4.444a4.444 4.444 0 0 1 8.888 0V8M8 11.556v2.666"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }